import React, { Component } from "react";
import * as dayjs from "dayjs";
import { PageTitle, LoadingSpinner, TruncatedCell } from "../../common";
import { useApiRequests } from "../../services";
import "./styles.scss";

const isAdminNotesEnabled = process.env.REACT_APP_FEATURE_ADMIN_NOTES === 'true';

export class MyRequests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myRequests: [],
      requestKudosTypesValues: {},
      isDataFetching: true,
    };
  }

  async componentDidMount() {
    const { getMyRequests, getRequestKudosTypesValuesById } = useApiRequests();
    try {
      const response = await getMyRequests();
      const myRequests = response.data;

      const requestKudosTypesValues = {};
      const promises = myRequests.map(async (request) => {
        if (request.requestTypeId === 3 && request.requestKudosTypeValueId) {
          const kudosTypeValueResponse = await getRequestKudosTypesValuesById(request.requestKudosTypeValueId);
          requestKudosTypesValues[request.requestKudosTypeValueId] = kudosTypeValueResponse.data.name;
        }
      });

      await Promise.all(promises);

      this.setState({
        myRequests,
        requestKudosTypesValues,
        isDataFetching: false,
      });
    } catch (error) {
      console.log(error.message);
      this.setState({ isDataFetching: false });
    }
  }

  renderRequestType(requestTypeId) {
    switch (requestTypeId) {
      case 1:
        return "Person to Person";
      case 2:
        return "Product";
      case 3:
        return "Kudos Request";
      default:
        return "Unknown";
    }
  }

  renderRequestDescription(request) {
    const { requestKudosTypesValues } = this.state;
    switch (request.requestTypeId) {
      case 1:
        return `Send ${request.kudosToTransfer} kudos to ${request.receiverFullName}. Comment: ${request.description}`;
      case 2:
        return `Purchase ${request.productName} for ${request.productPrice} kudos. Comment: ${request.description}`;
      case 3:
        const requestKudosTypeValue = requestKudosTypesValues[request.requestKudosTypeValueId];
        return `Request ${request.kudosToTransfer} kudos for ${request.receiverFullName} for: ${requestKudosTypeValue}. Comment: ${request.description}`;
      default:
        return "Unknown request type";
    }
  }

  renderStatusBadge(requestStatusId) {
    switch (requestStatusId) {
      case 1:
        return <span className="badge badge-warning">Pending</span>;
      case 2:
        return <span className="badge badge-success">Approved</span>;
      case 3:
        return <span className="badge badge-danger">Rejected</span>;
      default:
        return <span className="badge">Unknown</span>;
    }
  }

  renderAdminNotes(request) {
    if (request.requestStatusId === 1) {
      return <span className="no-notes">-</span>;
    }

    if (request.adminNotes) {
      return <TruncatedCell text={request.adminNotes} />;
    }

    return <span className="no-notes">No notes</span>;
  }

  render() {
    const { isDataFetching, myRequests } = this.state;

    if (isDataFetching) {
      return <LoadingSpinner message="Loading..." />;
    }

    return (
      <>
        <PageTitle title="My Requests" />
        <div className="col-12">
          <div className="shadow-50">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Description</th>
                  <th>Status</th>
                  {isAdminNotesEnabled && <th>Admin Notes</th>}
                </tr>
              </thead>
              <tbody>
                {myRequests.length === 0 ? (
                  <tr>
                    <td colSpan={isAdminNotesEnabled ? 5 : 4} className="text-center">No requests found</td>
                  </tr>
                ) : (
                  myRequests.map(request => {
                    const description = this.renderRequestDescription(request);
                    return (
                    <tr key={request.uniqueId}>
                      <td>{dayjs(request.date).format("dddd, MMM D, YYYY h:mm A")}</td>
                      <td>{this.renderRequestType(request.requestTypeId)}</td>
                      <td className="request-description-cell"><TruncatedCell text={description} /></td>
                      <td>{this.renderStatusBadge(request.requestStatusId)}</td>
                      {isAdminNotesEnabled && (
                        <td className="admin-notes-cell">
                          {this.renderAdminNotes(request)}
                        </td>
                      )}
                    </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }
}
